import { LocalizationButton } from '@magicdoor/ui';
import { useLocation } from '@solidjs/router';
import { createMemo, Show } from 'solid-js';
import MenuHamburger from '~/assets/images/common/menuHamburger.svg?component-solid';
import MenuHamburgerActive from '~/assets/images/common/menuHamburgerActive.svg?component-solid';
import { CompletionBarInNavigation } from '~/components/Onboarding/V2/CompletionBar';
import { useMenu } from '~/components/layouts/Menu/MenuContext';
import { useOnboarding } from '~/contexts/global';
import BreadcrumbContainer from './BreadcrumbContainer/BreadcrumbContainer';
import { CustomLayoutButton } from './CustomLayoutButton/CustomLayoutButton';
import SearchBar from './MagicSearchBar/MagicSearch';
import { SearchProvider } from './MagicSearchBar/MagicSearchContext';
import ProfileButton from './ProfileButton/ProfileButton';
interface NavigationProps {
  setIsSearchActive: (isSearchActive: boolean) => void;
}

const Navigation = (props: NavigationProps) => {
  const menu = useMenu();
  const { isOnboardingCompleted } = useOnboarding();
  const location = useLocation();
  const isHomePage = createMemo(() => ['/'].some((item) => item === location.pathname));

  return (
    <>
      <div
        class="fixed top-0 z-30 flex h-16 w-full bg-white px-3 md:pr-7"
        classList={{
          'md:w-layout-right': !menu?.isManuallyCollapsed(),
          'md:w-layout-full': menu?.isManuallyCollapsed(),
        }}>
        <div class="flex w-full items-center justify-between md:ml-0">
          <div class="flex items-center gap-2 md:hidden">
            <div onClick={() => menu?.setIsSidebarOpen((prev) => !prev)} class="cursor-pointer rounded-lg bg-gray-100 p-2">
              <Show when={!menu?.isSidebarOpen()} fallback={<MenuHamburgerActive class="size-5" />}>
                <MenuHamburger class="size-5" />
              </Show>
            </div>

            <div class="block h-4 w-px md:hidden" />
          </div>

          <div class="-mt-5px mr-auto max-w-[70%] overflow-hidden pt-1">
            <BreadcrumbContainer />
          </div>

          <SearchProvider>
            <div>
              <SearchBar setIsSearchActive={props.setIsSearchActive} />
            </div>
          </SearchProvider>

          <div class="flex items-center gap-2">
            <div class="h-4 w-px bg-input-border" />
            <Show when={!menu?.isMobile() && isHomePage() && isOnboardingCompleted()}>
              <CustomLayoutButton />
            </Show>
            <LocalizationButton />
            <ProfileButton />
          </div>
        </div>
      </div>

      <CompletionBarInNavigation />
    </>
  );
};

export default Navigation;
